import { createFileRoute } from '@tanstack/react-router';
import { FieldOpsView } from '@/components/field-ops';
import { TurfCutWalkthrough } from '@/components/field-ops/TurfCutWalkthrough';
import { FloatingHelp, HELP_TOPICS, OnboardingChecklistLink } from '@/components/help';

export const Route = createFileRoute('/app/field-ops')({
  component: FieldOpsPage,
});

function FieldOpsPage() {
  // TurfCutWalkthrough is mounted here (not inside FieldOpsView) so it survives FieldOpsView's
  // per-mode subtree swaps (management ↔ cutting). It reads the draw lifecycle from the store.
  return (
    <>
      <div className="h-[calc(100vh-64px)] w-full overflow-hidden">
        <FieldOpsView />
      </div>
      <TurfCutWalkthrough />
      <FloatingHelp topic={HELP_TOPICS.turf} footer={<OnboardingChecklistLink />} />
    </>
  );
}
